import script from "./GetPDFDataLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetPDFDataLoading.vue?vue&type=script&setup=true&lang=ts"

import "./GetPDFDataLoading.vue?vue&type=style&index=0&id=487e06e0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487e06e0"]])

export default __exports__